// extracted by mini-css-extract-plugin
export default {"vlLoader":"style_vlLoader__ECdsR"};